import yup from '../yup';

// tranlate to japanese
export const updatePasswordSchema = yup.object().shape({
  currentPassword: yup.string()
    .nullable()
    .required('Please enter your current password')
    .label('currentPassword'),
  newPassword: yup.string()
    .nullable()
    .required('Please enter a new password')
    .min(8, 'Password must be at least 8 characters')
    .matches(/^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)[a-zA-Z\d]{8,100}$/g, 'Password must include uppercase, lowercase, and numbers')
    .label('newPassword'),
  newPasswordConfirm: yup.string()
    .nullable()
    .required('Please confirm your new password')
    .oneOf([yup.ref('newPassword')], 'Passwords do not match')
    .label('newPasswordConfirm'),
});
